import { render } from "./income-statement.vue?vue&type=template&id=5c51dd6d&scoped=true"
import script from "./income-statement.vue?vue&type=script&lang=js"
export * from "./income-statement.vue?vue&type=script&lang=js"

import "./income-statement.vue?vue&type=style&index=0&id=5c51dd6d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c51dd6d"]])

export default __exports__